import { makeStyles } from 'tss-react/mui'
import { white } from '../../assets/colors'


export const useStyles = makeStyles()((theme) => {
    return {
        container: {
            position: 'fixed',
            zIndex: 9999,
            margin: 0,
            padding: 0,
            borderRadius: '4px',
            animation: 'slideInFromBottom 0.3s ease forwards',
            '@keyframes slideInFromBottom': {
                '0%': {
                    transform: 'translateY(100%)'
                },
                '100%': {
                    transform: 'translateY(0)'
                }
            }
        },
        header: {
            transition: theme.transitions.create(['background'], {
                duration: 300
            })
        },
        headerText: {
            color: white
        },
        advancedButton: {
            fontSize: '13px'
        },
        advancedActive: {
            transform: 'rotateZ(180deg)'
        },
        slTargetLabel: {
            fontSize: '12px'
        },
        disabledInputClickBackdrop: {
            position: "absolute",
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            zIndex: 1,
            cursor: 'pointer'
        }
    }
})